import { render, staticRenderFns } from "./si_maze.vue?vue&type=template&id=83776540&scoped=true&"
import script from "./si_maze.vue?vue&type=script&lang=js&"
export * from "./si_maze.vue?vue&type=script&lang=js&"
import style0 from "./si_maze.vue?vue&type=style&index=0&id=83776540&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83776540",
  null
  
)

export default component.exports